import { FunctionComponent, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import config from '~/config';
import history from '~/history';
import { clearAuth } from '~/store/auth';
import { clearAllDictionaries } from '~/store/main';
import {
  clearJobCardsNotRunning,
  clearJobCardsRunning,
  clearJobCardsRecently,
  clearJobCardReports,
  clearSelectedJobCard,
  clearJobCardFilter,
} from '~/store/jobCard';
import { removeEmployeeId, removeBranch, removeLanguage } from '~/utils/sessionStorage';
import { clearTokens } from '~/utils/token';

const Logout: FunctionComponent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    // Clear server-side cookies
    axios.post(`${config.apiUrl}/auth/logout`, {}, { withCredentials: true }).catch(() => {});

    removeEmployeeId();
    removeBranch();
    clearTokens();
    dispatch(clearAuth());
    dispatch(clearJobCardFilter());
    dispatch(clearAllDictionaries());
    dispatch(clearJobCardReports());
    dispatch(clearJobCardsRunning());
    dispatch(clearJobCardsNotRunning());
    dispatch(clearJobCardsRecently());
    dispatch(clearSelectedJobCard());
    history.goToLogin();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <></>;
};

export default Logout;
